function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { useCallback } from 'react';
import { useTableUtils } from "./useTableUtils.js";
/**
 * Returns a function that gets the index of the first row containing a column
 * value.
 * @param columnName The name of the column to search
 * @param value The value to search for
 * @param table The table to search in
 * @returns A function that returns the index of the first row containing the
 * matching value, or `null` if no match is found
 */
export function useGetItemIndexByValue(_ref) {
  var columnName = _ref.columnName,
    value = _ref.value,
    table = _ref.table;
  var tableUtils = useTableUtils();
  return useCallback(/*#__PURE__*/_asyncToGenerator(function* () {
    if (table == null || value == null || columnName == null) {
      return null;
    }
    var column = table.findColumn(columnName);
    var columnValueType = tableUtils.getValueType(column.type);
    var index = yield table.seekRow(0, column, columnValueType, value);
    return index === -1 ? null : index;
  }), [columnName, table, tableUtils, value]);
}
export default useGetItemIndexByValue;
//# sourceMappingURL=useGetItemIndexByValue.js.map